<template>
<section class="freebook_consultant" style="padding: 20px 0px 3px; background:#fff">
    <swiper v-if="bannerItems.length > 0"
        class="swiper main_slide_cc"
        :options="swiperOption"
    >
        <swiper-slide class="item" v-for="banner in bannerItems" :key="banner.id" >
            <a @click="openWindow(banner.content)" class="">
                <div class="main-banner-img carousel-shadow">
                    <img :src="banner.bannerUrl">
                </div>
            </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>

    </swiper>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { DateFormatMixin } from '../../mixins/DateFormatMixin';

export default {
    name:'MainAdBanner',
    mixins:[DateFormatMixin],
    components: {},
    created () {},
    props: {
        onload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            swiperOption: {
                loop: true, 
                autoHeight: true, //enable auto height
                spaceBetween: 5, //거리
                autoplay: false/*{ 
                    delay: 4000, 
                    disableOnInteraction: false,
                }*/,
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            bannerItems: [],
            bannerItemsOnload: [],
        }
    },
    
    watch: {
        onload(val) {
            if(val) {
                this.bannerItems = this.bannerItemsOnload;
            }
        }
    },

    computed: {
        ...mapState({
            BANNER_DTYPE_ADVERTISEMENT_ID: state => state.codeDictionary.items.BANNER_DTYPE.ADVERTISEMENT.id
        }),
    },

    methods: {
        async getItems() {
            let today = this.dayjsFormat(this.getToday() , 'YYYY-MM-DD');
            await this.$store.dispatch('GET_BANNER_LIST',{ 
                type:this.BANNER_DTYPE_ADVERTISEMENT_ID,
                sort : 'startDt,DESC',
                showYn: 'Y',
                showDt: today
            })
            .then((data)=>{
                this.bannerItemsOnload = data.content;
            }).catch((e)=> {
                throw e;
            }); 
        }
    },
}
</script>

<style lang="scss" scoped>

</style>